export const translations = {
  es: {
    nav: {
      hablemos: 'Hablemos',
    },
    hero: {
      title1: 'Tu negocio merece clientes reales.',
      title2: 'No seguidores. No alcance.',
      title3: 'Clientes.',
      subtitle:
        'Diseñamos marcas y sitios web con intención, identidad y estrategia.',
      cta: 'HABLEMOS',
      ctaSub: 'Sin formularios largos. Solo una conversación.',
      scroll: 'Scroll',
    },
    problem: {
      title:
        'Cada día sin una presencia poderosa, es un cliente que elige a otro.',
      badTitle: 'Así se ven hoy',
      badPoints: [
        'Sitio web genérico',
        'Plantilla obvia',
        'Sin personalidad',
        'Texto aburrido',
      ],
      goodTitle: 'Así podrías verte',
      goodPoints: [
        'Diseño premium',
        'Identidad clara',
        'Mensaje que conecta',
        'CTA visible',
      ],
      flowchart: {
        start: 'Alguien escucha de tu negocio...',
        badPath: {
          title: 'Tu web hoy',
          points: ['❌ Sin confianza', '❌ Sin identidad', '❌ Sin dirección'],
          result: 'Se va',
        },
        goodPath: {
          title: 'Después de Profumind',
          points: ['✅ Imagen clara', '✅ Mensaje fuerte', '✅ CTA visible'],
          result: 'Te elige a ti',
        },
      },
      conclusion1:
        'No porque seas peor. No porque tu precio esté mal. Sino porque en los primeros 5 segundos, tu imagen no genera confianza.',
      conclusion2: 'Y en internet, 5 segundos es todo lo que tienes.',
    },
    mechanism: {
      title: 'Presencia con Intención',
      subtitle:
        'No es solo diseño bonito. Es cada decisión visual y estratégica alineada para generar una sola cosa:',
      word: 'C O N F I A N Z A',
      quote:
        'Porque la confianza es lo que convierte un visitante en un cliente.',
      badCard: {
        title: 'Marca Genérica',
        points: [
          "Se ve 'normal'",
          'No diferencia',
          'Fuerza explicar',
          'Compite por precio',
          'El cliente duda',
        ],
      },
      goodCard: {
        title: 'Marca con Intención',
        points: [
          'Genera confianza',
          'Comunica valor',
          'Posiciona sola',
          'Atrae por valor',
          'El cliente confía',
        ],
      },
    },
    services: {
      title: 'Cómo construimos tu presencia',
      items: [
        {
          title: 'SITIOS WEB',
          sub: 'Tu mejor vendedor 24/7',
          desc: 'No te damos una página web. Te damos tu mejor vendedor disponible las 24 horas.',
        },
        {
          title: 'BRANDING',
          sub: 'La imagen que genera confianza',
          desc: 'Construimos una identidad visual que hace que tu negocio se sienta premium, coherente y memorable.',
        },
        {
          title: 'CONTENIDO',
          sub: 'Contenido que convierte',
          desc: 'Cada pieza de contenido tiene una función estratégica dentro de tu ecosistema de marca.',
        },
        {
          title: 'ESTRUCTURA DE MARCA',
          sub: 'Arquitectura de mensaje',
          desc: 'Construimos la arquitectura de mensaje para que cada punto de contacto sea coherente y convincente.',
        },
        {
          title: 'CAPTACIÓN',
          sub: 'Estrategia que atrae',
          desc: 'Diseñamos la estrategia para que tu marca trabaje activamente en conseguirte los clientes correctos.',
        },
      ],
    },
    process: {
      title: 'Así transformamos tu presencia',
      items: [
        {
          num: '01',
          title: 'ESCUCHA',
          desc: 'Entendemos tu negocio, tu cliente y tu visión',
        },
        {
          num: '02',
          title: 'ESTRATEGIA',
          desc: 'Definimos tu identidad, mensaje y estructura',
        },
        {
          num: '03',
          title: 'CREACIÓN',
          desc: 'Diseñamos cada pieza con intención estratégica',
        },
        {
          num: '04',
          title: 'LANZAMIENTO',
          desc: 'Tu marca sale al mundo lista para atraer',
        },
      ],
    },
    socialProof: {
      counters: [
        'Marcas con identidad nueva',
        'Enfoque en clientes reales',
        'Para generar confianza o perder',
      ],
      title: 'El Impacto Real',
      before: 'Antes de Profumind',
      after: 'Después de Profumind',
      bars: ['Presencia digital', 'Confianza percibida', 'Clientes atraídos'],
    },
    identity: {
      title: '¿Esto es para ti?',
      items: [
        {
          title: 'EMPRENDEDOR',
          desc: 'Tienes un negocio real y quieres una imagen a su altura',
        },
        {
          title: 'FREELANCER / PROFESIONAL',
          desc: 'Tu trabajo es excelente pero tu imagen no lo grita',
        },
        {
          title: 'MARCA PERSONAL',
          desc: 'Sabes lo que vales pero tu imagen no lo refleja aún',
        },
        {
          title: 'NEGOCIO EN CRECIMIENTO',
          desc: 'Quieres dejar de competir por precio y atraer por valor',
        },
      ],
    },
    cta: {
      title: '¿Listo para que tu marca comunique lo que realmente vales?',
      whatsapp: 'Hablemos por WhatsApp',
      instagram: 'Síguenos en Instagram',
      sub: 'Sin formularios largos. Una conversación real.',
      quote:
        '"Lo importante no son los números. Son los clientes que logramos atraer."',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      items: [
        {
          q: 'Es muy caro para mí ahora',
          a: 'El costo de no tener una imagen profesional es invisible pero constante. Cada cliente que te elige a la competencia por cómo se ven es dinero que ya estás perdiendo. La pregunta no es si puedes pagarlo — es si puedes seguir sin ello.',
        },
        {
          q: 'Ya intenté esto antes y no funcionó',
          a: 'La mayoría de proyectos de diseño fallan porque el proveedor entrega estética sin estrategia. Profumind construye desde la estrategia hacia afuera. La diferencia está en el proceso, no en el software.',
        },
        {
          q: 'Necesito pensarlo',
          a: 'Completamente válido. Pero considera que mientras lo piensas, alguien más está buscando exactamente lo que tú ofreces — y eligiendo a quien se ve más confiable.',
        },
        {
          q: '¿Cómo sé que van a entender mi negocio?',
          a: 'Empezamos siempre con escucha activa. Nada se diseña antes de entender quién eres, a quién le hablas y qué hace único a tu negocio.',
        },
        {
          q: '¿Cuánto tiempo toma?',
          a: 'Depende del alcance, pero nuestro proceso está diseñado para ser eficiente sin sacrificar calidad. Trabajamos con timelines claros desde el primer día.',
        },
      ],
    },
    footer: {
      quote:
        '"Lo importante no son los números. Son los clientes que logramos atraer."',
      copyright: '© Profumind — Marcas con intención, identidad y estrategia.',
    },
  },
  en: {
    nav: {
      hablemos: "Let's Talk",
    },
    hero: {
      title1: 'Your business deserves real clients.',
      title2: 'Not followers. Not reach.',
      title3: 'Clients.',
      subtitle:
        'We design brands and websites with intention, identity, and strategy.',
      cta: "LET'S TALK",
      ctaSub: 'No long forms. Just a conversation.',
      scroll: 'Scroll',
    },
    problem: {
      title:
        'Every day without a powerful presence is a client choosing someone else.',
      badTitle: 'How they look today',
      badPoints: [
        'Generic website',
        'Obvious template',
        'No personality',
        'Boring copy',
      ],
      goodTitle: 'How you could look',
      goodPoints: [
        'Premium design',
        'Clear identity',
        'Message that connects',
        'Visible CTA',
      ],
      flowchart: {
        start: 'Someone hears about your business...',
        badPath: {
          title: 'Your web today',
          points: ['❌ No trust', '❌ No identity', '❌ No direction'],
          result: 'They leave',
        },
        goodPath: {
          title: 'After Profumind',
          points: ['✅ Clear image', '✅ Strong message', '✅ Visible CTA'],
          result: 'They choose you',
        },
      },
      conclusion1:
        "Not because you're worse. Not because your price is wrong. But because in the first 5 seconds, your image doesn't build trust.",
      conclusion2: 'And on the internet, 5 seconds is all you have.',
    },
    mechanism: {
      title: 'Presence with Intention',
      subtitle:
        'It is not just pretty design. It is every visual and strategic decision aligned to generate one thing:',
      word: 'T R U S T',
      quote: 'Because trust is what turns a visitor into a client.',
      badCard: {
        title: 'Generic Brand',
        points: [
          "Looks 'normal'",
          'Does not stand out',
          'Forces you to explain',
          'Competes on price',
          'Client doubts',
        ],
      },
      goodCard: {
        title: 'Brand with Intention',
        points: [
          'Builds trust',
          'Communicates value',
          'Positions itself',
          'Attracts by value',
          'Client trusts',
        ],
      },
    },
    services: {
      title: 'How we build your presence',
      items: [
        {
          title: 'WEBSITES',
          sub: 'Your best salesperson 24/7',
          desc: 'We do not give you a webpage. We give you your best salesperson available 24 hours a day.',
        },
        {
          title: 'BRANDING',
          sub: 'The image that builds trust',
          desc: 'We build a visual identity that makes your business feel premium, cohesive, and memorable.',
        },
        {
          title: 'CONTENT',
          sub: 'Content that converts',
          desc: 'Every piece of content has a strategic function within your brand ecosystem.',
        },
        {
          title: 'BRAND STRUCTURE',
          sub: 'Message architecture',
          desc: 'We build the message architecture so every touchpoint is cohesive and convincing.',
        },
        {
          title: 'ACQUISITION',
          sub: 'Strategy that attracts',
          desc: 'We design the strategy so your brand actively works to get you the right clients.',
        },
      ],
    },
    process: {
      title: 'How we transform your presence',
      items: [
        {
          num: '01',
          title: 'LISTEN',
          desc: 'We understand your business, your client, and your vision',
        },
        {
          num: '02',
          title: 'STRATEGY',
          desc: 'We define your identity, message, and structure',
        },
        {
          num: '03',
          title: 'CREATION',
          desc: 'We design every piece with strategic intention',
        },
        {
          num: '04',
          title: 'LAUNCH',
          desc: 'Your brand goes out to the world ready to attract',
        },
      ],
    },
    socialProof: {
      counters: [
        'Brands with new identity',
        'Focus on real clients',
        'To build trust or lose it',
      ],
      title: 'The Real Impact',
      before: 'Before Profumind',
      after: 'After Profumind',
      bars: ['Digital presence', 'Perceived trust', 'Clients attracted'],
    },
    identity: {
      title: 'Is this for you?',
      items: [
        {
          title: 'ENTREPRENEUR',
          desc: 'You have a real business and want an image to match',
        },
        {
          title: 'FREELANCER / PROFESSIONAL',
          desc: 'Your work is excellent but your image does not scream it',
        },
        {
          title: 'PERSONAL BRAND',
          desc: 'You know your worth but your image does not reflect it yet',
        },
        {
          title: 'GROWING BUSINESS',
          desc: 'You want to stop competing on price and attract by value',
        },
      ],
    },
    cta: {
      title: 'Ready for your brand to communicate what you are really worth?',
      whatsapp: "Let's talk on WhatsApp",
      instagram: 'Follow us on Instagram',
      sub: 'No long forms. A real conversation.',
      quote:
        '"The important thing is not the numbers. It is the clients we manage to attract."',
    },
    faq: {
      title: 'Frequently Asked Questions',
      items: [
        {
          q: 'It is too expensive for me right now',
          a: 'The cost of not having a professional image is invisible but constant. Every client that chooses your competition because of how they look is money you are already losing. The question is not if you can afford it — it is if you can afford to continue without it.',
        },
        {
          q: 'I tried this before and it did not work',
          a: 'Most design projects fail because the provider delivers aesthetics without strategy. Profumind builds from strategy outwards. The difference is in the process, not the software.',
        },
        {
          q: 'I need to think about it',
          a: 'Completely valid. But consider that while you think about it, someone else is searching for exactly what you offer — and choosing whoever looks more trustworthy.',
        },
        {
          q: 'How do I know you will understand my business?',
          a: 'We always start with active listening. Nothing is designed before understanding who you are, who you are talking to, and what makes your business unique.',
        },
        {
          q: 'How long does it take?',
          a: 'It depends on the scope, but our process is designed to be efficient without sacrificing quality. We work with clear timelines from day one.',
        },
      ],
    },
    footer: {
      quote:
        '"The important thing is not the numbers. It is the clients we manage to attract."',
      copyright:
        '© Profumind — Brands with intention, identity, and strategy.',
    },
  },
}
